import React from "react";
import { Alert, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TransactionV2TypeEnum } from "@bn/api/apiv1";
import WarningIcon from "@icons/myicons/warning-triangle-filled.svg?react";

interface AddManuallyWarningsProps {
  transactionType?: TransactionV2TypeEnum;
}

export const AddManuallyWarnings = ({
  transactionType,
}: AddManuallyWarningsProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  if (transactionType === "other_gains") {
    return (
      <Alert
        data-testid="option-alert-warning"
        color="warning"
        icon={
          <WarningIcon
            width="30px"
            height="30px"
            color={theme.palette.warning.main}
          />
        }
      >
        {t("addManuallyPage.form.hints.other_gains")}
      </Alert>
    );
  }

  return null;
};
